import s from "./td-longtail-vue-components172.js";
/* empty css                              */
import r from "./td-longtail-vue-components98.js";
var i = function() {
  var e = this, a = e._self._c, t = e._self._setupProxy;
  return a("div", { ref: "imageTeaserElement", staticClass: "image-teaser", class: t.componentClass, style: t.componentStyles }, [a("div", { staticClass: "image-teaser__background-container" }, [e._t("bgImage", function() {
    return [e.background?.src ? a(t.PictureElement, { staticClass: "image-teaser__background-image", attrs: { src: e.background.src, "src-sm": e.background.srcSm, "src-md": e.background.srcMd, "src-lg": e.background.srcLg, lazy: e.lazy, sizes: e.background.sizes, "image-style": e.background.style, alt: e.background.alt } }) : e._e()];
  })], 2), a("div", { ref: "containerElement", staticClass: "image-teaser__container" }, [e.hasBadge ? a(t.Badge, { staticClass: "image-teaser__badge", attrs: { "auto-width": "" } }, [e._t("badge")], 2) : e._e(), e._t("heading", function() {
    return [e.heading?.text ? a(t.Heading, e._b({ staticClass: "image-teaser__title", attrs: { size: e.heading.size || "md", tag: e.heading.tag || "h2" } }, "Heading", e.heading, !1)) : e._e()];
  }), e._t("copy", function() {
    return [e.description ? a(t.Paragraph, { staticClass: "image-teaser__copy", attrs: { "no-margin": "" } }, [e._v(" " + e._s(e.description) + " ")]) : e._e()];
  }), e._t("image", function() {
    return [e.image?.src ? a(t.PictureElement, { ref: "imageElement", staticClass: "image-teaser__image", style: e.image.style, attrs: { src: e.image.src, "src-sm": e.image.srcSm, "src-md": e.image.srcMd, "src-lg": e.image.srcLg, lazy: e.lazy, sizes: e.image.sizes, alt: e.image.alt } }) : e._e()];
  }), e.$slots.default ? a("div", { staticClass: "image-teaser__default" }, [e._t("default")], 2) : e._e(), a("div", { staticClass: "image-teaser__button" }, [e._t("button")], 2)], 2)]);
}, n = [], c = /* @__PURE__ */ r(
  s,
  i,
  n,
  !1,
  null,
  "02797f3e"
);
const o = c.exports;
export {
  o as default
};
